import React from 'react';
export var ThemeContext = /*#__PURE__*/React.createContext({});
export default ThemeContext;
//# sourceMappingURL=ThemeContext.js.map